import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { Header } from '@/components/layout/Header';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { 
  Breadcrumb, 
  BreadcrumbItem, 
  BreadcrumbLink, 
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator 
} from '@/components/ui/breadcrumb';
import { VSLeadsMetricsContent } from '@/components/vsleads/metrics/VSLeadsMetricsContent';

export default function VSLeadsMetrics() {
  useLanguage();
  const { videoId } = useParams<{ videoId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const captureType = searchParams.get('type') || 'email';
  const videoName = 'Webinar de Lançamento'; // TODO: Buscar do estado/API

  return (
    <Layout fixedSidebar>
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="p-6 border-b">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/vsleads">{translateInterfaceText("Captura de Leads")}</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{translateInterfaceText("Vídeos")}</BreadcrumbPage>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{videoName}</BreadcrumbPage>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{translateInterfaceText("Métricas")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          
          <div className="flex items-center gap-3 mt-4">
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => navigate('/vsleads')}
              className="flex items-center gap-1.5"
            >
              <ArrowLeft className="h-4 w-4" />
              {translateInterfaceText("Voltar")}</Button>
            <h1 className="text-2xl font-semibold">
              {translateInterfaceText("📊 Métricas —")}{" "}{videoName}
            </h1>
          </div>
          <p className="text-sm text-muted-foreground mt-2">
            {translateInterfaceText("Dados em tempo real sobre desempenho de captura para este vídeo")}</p>
        </div>
        <main className="flex-1 overflow-y-auto">
          <div className="container mx-auto p-6">
            <VSLeadsMetricsContent 
              videoId={videoId!} 
              captureType={captureType as 'email' | 'senha'} 
            />
          </div>
        </main>
      </div>
    </Layout>
  );
}
